import { combineLatest, Observable, of, take, mergeMap } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Injectable } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';

import { OfflineFacade, UserDetailsFacade } from '@shared/state/facades';
import { DprDetails } from '@shared/models/dpr';
import { ProgressStockService } from '../progress-stock.service';

@UntilDestroy()
@Injectable()
export class DprProgressOfflineService {
  constructor(
    private userDetailsFacade: UserDetailsFacade,
    private offlineFacade: OfflineFacade,
    private progressStockService: ProgressStockService
  ) {}

  updateDependentProgressPrevValues(startDate: Date): Observable<boolean> {
    return combineLatest([
      this.userDetailsFacade.query.projectSetup$,
      this.offlineFacade.query.combinedDprDetailsList$,
    ]).pipe(
      untilDestroyed(this),
      take(1),
      mergeMap(([projectSetup, dprDetailsList]) => {
        const progressList = projectSetup?.progress?.progressItems ?? [];
        const dprDetailsCopy = cloneDeep(dprDetailsList) as DprDetails[];

        progressList.forEach((progress) => {
          const items = dprDetailsCopy
            .filter((x) => new Date(x.dprDateTime) >= new Date(startDate))
            .sort((a, b) => {
              return (
                new Date(a.dprDateTime).valueOf() -
                new Date(b.dprDateTime).valueOf()
              );
            });

          for (let i = 1; i < items.length; i++) {
            const prevItem = (
              items[i - 1].dprProgress.dprProgressDetails || []
            ).find((x) => x.progressId === progress.id);
            const currentItem = (
              items[i].dprProgress.dprProgressDetails || []
            ).find((x) => x.progressId === progress.id);

            if (prevItem && currentItem) {
              currentItem.progressStockDetails =
                this.progressStockService.onPreviousDayChanged(
                  prevItem.progressStockDetails,
                  progress.initialValue,
                  currentItem,
                  currentItem.progressStockDetails
                );

              this.offlineFacade.setDprDetails(cloneDeep(items[i]));
            }
          }
        });
        return of(true);
      })
    );
  }
}
